import { useOrder, duplicateOrder } from '../data/order'
import AuthService from '../services/authentication';
import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Button, Input, Label } from "../ui"

function DuplicateOrderForm({ orderID, patient }) {
  let auth = AuthService.useAuth();
  let history = useHistory()
  const [formValues, setFormValues] = useState({
    email: patient.patient_email || '',
    firstName: patient.patient_first_name || '',
    lastName: patient.patient_last_name || '',
    phone: patient.patient_phone || ''
  })

  const { order, mutate } = useOrder(auth.authHeader());

  useEffect(() => {
    setFormValues({
      email: patient.patient_email || '',
      firstName: patient.patient_first_name || '',
      lastName: patient.patient_last_name || '',
      phone: patient.patient_phone || ''
    });
  }, [patient]);

  const handleSubmit = async event => {
    event.preventDefault();
    try {
      const response = await duplicateOrder({
        id: orderID,
        patient: {
          ...formValues,
        },
        auth_header: auth.authHeader()
      });
      mutate()
      history.push("/order/edit");
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = event => {
    const target = event.target
    const value = target.value
    const name = target.name
    setFormValues({
      ...formValues,
      [name]: value
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-12 gap-2">
        {patient.label && <Label className="col-span-12">{patient.label}</Label>}
        <div className="col-span-6">
          <Input name="firstName" value={formValues.firstName} required onChange={handleInputChange} type="text" placeholder="Patient first name" />
        </div>
        <div className="col-span-6">
          <Input name="lastName" value={formValues.lastName} required onChange={handleInputChange} type="text" placeholder="Patient last name" />
        </div>
        <div className="col-span-12">
            <Input name="email" value={formValues.email} required onChange={handleInputChange} type="email" placeholder="Patient email address" />
        </div>
        <div className="col-span-12">
            <Input name="phone" value={formValues.phone} required onChange={handleInputChange} type="text" placeholder="Patient phone number" />
        </div>
        <div className="col-span-6">
          <Button variant="primary" className="mrt-4" type="submit">Next</Button>
        </div>
      </div>
    </form>
  )
}

export default DuplicateOrderForm
